<section class="page">

  <!-- HERO -->
  <header class="hero">
    <div class="hero__bg">
      <div class="hero__orb hero__orb--primary"></div>
      <div class="hero__orb hero__orb--secondary"></div>
    </div>
    <div class="hero__content">
      <div class="hero__kicker">{{ 'home.pricing.hero.kicker' | translate }}</div>
      <h1 class="hero__title">{{ 'home.pricing.hero.title' | translate }}</h1>
      <p class="hero__subtitle">{{ 'home.pricing.hero.subtitle' | translate }}</p>
    </div>
  </header>

  <section class="section">
    <div class="grid grid--pricing">
      @for (pod of pods; track pod.name) {
        <mat-card class="card card--pricing" [class.card--highlighted]="pod.highlighted">
          @if (pod.highlighted) {
            <div class="badge">{{ 'home.pricing.popular' | translate }}</div>
          }

          <mat-card-header>
            <mat-card-title>{{ 'home.pricing.pods.' + pod.name + '.title' | translate }}</mat-card-title>
            <mat-card-subtitle>{{ 'home.pricing.pods.' + pod.name + '.subtitle' | translate }}</mat-card-subtitle>
          </mat-card-header>

          <mat-card-content>
            <div class="price">
              <span class="price__currency">&euro;</span>
              <span class="price__amount">{{ pod.price }}</span>
              @if (pod.creditCovered) {
                <span class="price__note">{{ 'home.pricing.firstMonth' | translate }}<sup class="price__mark">*</sup></span>
              }
            </div>

            <ul class="specs">
              <li>
                <mat-icon>memory</mat-icon>
                <span>{{ pod.vcpu }} vCPU</span>
              </li>
              <li>
                <mat-icon>sd_storage</mat-icon>
                <span>{{ pod.ram }} RAM</span>
              </li>
              <li>
                <mat-icon>storage</mat-icon>
                <span>{{ pod.storage }} {{ 'home.pricing.storage' | translate }}</span>
              </li>
            </ul>
          </mat-card-content>

          <mat-card-actions>
            <a mat-flat-button routerLink="/register" class="btn-action" [class.btn-action--primary]="pod.highlighted">
              {{ 'home.pricing.cta' | translate }}
            </a>
          </mat-card-actions>
        </mat-card>
      }
    </div>

    <p class="pricing-note">{{ 'home.pricing.creditNote' | translate }}</p>
  </section>

  <section class="section">
    <div class="section__head">
      <h2 class="section__title">{{ 'home.pricing.addons.title' | translate }}</h2>
    </div>

    <div class="grid grid--addons">
      <article class="addon-card">
        <div class="addon-card__icon">
          <mat-icon>storage</mat-icon>
        </div>
        <div class="addon-card__body">
          <h3 class="addon-card__title">{{ 'home.pricing.disk.title' | translate }}</h3>
          <p class="addon-card__desc">{{ 'home.pricing.disk.note' | translate }}</p>
        </div>
      </article>

      <article class="addon-card">
        <div class="addon-card__icon">
          <mat-icon>public</mat-icon>
        </div>
        <div class="addon-card__body">
          <h3 class="addon-card__title">{{ 'home.pricing.replica.title' | translate }}</h3>
          <p class="addon-card__desc">{{ 'home.pricing.replica.note' | translate }}</p>
        </div>
      </article>
    </div>
  </section>

</section>
